
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/eloqua",
      function () {
        return require("private-next-pages/destinations/eloqua.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/eloqua"])
      });
    }
  